module.exports = __webpack_public_path__ + "img/Bot_Illustration.af69d1d1.png";